import { SET_CART_DATA } from "../actions/cart-action-type";

const initialState = {
  cart: [],
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case SET_CART_DATA:
      return {
        ...state,
        cart: [...state.cart, action.payload],
      };
    default:
      return state;
  }
};

export default user;
